import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ConfigService } from '../service/config.service';
 
@Directive({
  selector: '[removeIfFeatureOff]'
})
export class RemoveIfFeatureOffDirective implements OnInit {
  @Input('removeIfFeatureOff') featureName: string;
 
  constructor(private el: ElementRef,
              private configService: ConfigService) {
  }
 
  ngOnInit() {
    if (this.configService.featureOff(this.featureName)) {
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }
}